import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils/typings';

const { name, version } = __serviceInfo__;

export const serviceNames = {
    rampService: 'RAMP_SERVICE',
    routerStore: 'ROUTER_STORE',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    configRepository: 'CONFIG_REPOSITORY',
    translationRepository: 'TRANSLATION_REPOSITORY',
    dropdownDataStore: 'DROPDOWN_DATA_STORE',
    logger: 'LOGGER',
    signUpViewController: 'SIGN_UP_VIEW_CONTROLLER',
    rampViewController: 'RAMP_VIEW_CONTROLLER',
    rampMainViewController: 'RAMP_MAIN_VIEW_CONTROLLER',
    rampSocialProfileViewController: 'RAMP_SOCIAL_PROFILE_VIEW_CONTROLLER',
    loginViewController: 'LOGIN_IN_VIEW_CONTROLLER',
    qrCodeViewController: 'QR_CODE_VIEW_CONTROLLER',
    redirectViewController: 'REDIRECT_VIEW_CONTROLLER',
    rampSdApiSdk: 'RAMP_SD_API_SDK',
    rampPgApiSdk: ' RAMP_PG_API_SDK',
    httpTransport: 'HTTP_TRANSPORT',
    userRepository: 'USER_REPOSITORY',
    userFormViewController: 'USER_FORM',
    apiDataMapper: 'API_DATA_MAPPER',
    apiDropDownRepository: 'API_DROPDOWN_REPOSITORY',
    apiDropDownViewController: 'API_DROPDOWN_VIEW_CONTROLLER'
};

export default serviceNames;

export class RampService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}
